import { render } from "./ChatAppPage.vue?vue&type=template&id=6dac17cc&scoped=true"
import script from "./ChatAppPage.vue?vue&type=script&lang=js"
export * from "./ChatAppPage.vue?vue&type=script&lang=js"

import "./ChatAppPage.vue?vue&type=style&index=0&id=6dac17cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dac17cc"]])

export default __exports__